(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // TrendLane — transparent header solidifies after scrolling past the hero
  (function () {
    var el = document.getElementById('ss-header-wrapper');
    if (!el) return;
    var THRESHOLD = 60;
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > THRESHOLD) {
        el.classList.add('ss-scrolled');
      } else {
        el.classList.remove('ss-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSsSlider(root) {
      if (root.dataset.ssSliderInit === 'true') return;
      root.dataset.ssSliderInit = 'true';

      var track = root.querySelector('.ss-hero-slider__track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.ss-hero-slider__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));

      if (slides.length <= 1) return;

      var index = 0;
      var timer = null;
      var autoplayMs = parseInt(root.getAttribute('data-autoplay') || '0', 10);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobileSwipeQuery = window.matchMedia('(max-width: 749px)');

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (slide, si) {
          var active = si === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, di) {
          var active = di === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        // The track is never transformed on any breakpoint now. Mobile and
        // desktop both change slides with the same crossfade, which is the
        // path that has always rendered correctly; the swipe handlers
        // below just call this function. Clearing the property defensively
        // so a stale transform from a cached older copy of this file can't
        // leave the track parked on an empty slide.
        if (track) {
          track.style.transform = '';
        }
      }

      function next() {
        goTo(index + 1);
      }

      function prev() {
        goTo(index - 1);
      }

      function start() {
        if (!autoplayMs || reducedMotion) return;
        stop();
        timer = setInterval(next, autoplayMs);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function restart() {
        stop();
        start();
      }

      dots.forEach(function (dot, di) {
        dot.addEventListener('click', function () {
          goTo(di);
          restart();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      // Touchscreen swipe (phones/tablets).
      var touchStartX = null;
      if (track) {
        track.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.touches[0].clientX;
            stop();
          },
          { passive: true }
        );
        track.addEventListener(
          'touchend',
          function (e) {
            if (touchStartX === null) return;
            var dx = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(dx) > 40) {
              dx < 0 ? next() : prev();
            }
            touchStartX = null;
            start();
          },
          { passive: true }
        );

        // Trackpad swipe (laptops). A two-finger horizontal swipe on a
        // trackpad fires wheel events with deltaX rather than touch events,
        // so it needs its own handler. Accumulate deltaX and lock out
        // further triggers until the gesture pauses, so one swipe = one
        // slide change instead of several.
        var wheelDeltaX = 0;
        var wheelLocked = false;
        var wheelResetTimer = null;

        track.addEventListener(
          'wheel',
          function (e) {
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;

            stop();
            wheelDeltaX += e.deltaX;

            clearTimeout(wheelResetTimer);
            wheelResetTimer = setTimeout(function () {
              wheelDeltaX = 0;
              wheelLocked = false;
              start();
            }, 200);

            if (wheelLocked) return;

            if (Math.abs(wheelDeltaX) > 60) {
              wheelLocked = true;
              wheelDeltaX > 0 ? next() : prev();
            }
          },
          { passive: true }
        );
      }

      // Re-sync if the viewport crosses the 749px breakpoint — e.g.
      // rotating a phone, or resizing a browser window while testing.
      mobileSwipeQuery.addEventListener('change', function () {
        goTo(index);
      });

      start();
    }

    document.querySelectorAll('[data-ss-slider]').forEach(initSsSlider);

    // Re-init after the Shopify theme editor swaps in fresh section HTML
    // (e.g. after a setting change), since that replaces the DOM nodes our
    // listeners were bound to.
    document.addEventListener('shopify:section:load', function (event) {
      var sliders = event.target.querySelectorAll
        ? event.target.querySelectorAll('[data-ss-slider]')
        : [];
      Array.prototype.forEach.call(sliders, initSsSlider);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ss-ptabs').forEach(function (root) {
      var tabs = root.querySelectorAll('.ss-ptabs__tab');
      var panels = root.querySelectorAll('.ss-ptabs__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
